import styled, { css } from 'styled-components';

import { font } from '../../../atoms/typography';
import { color } from '../../../atoms/colors';
import { spacing } from '../../../atoms/spacing';
import { atMinWidth } from '../../../atoms/breakpoints';

import {
  defaultStyles,
  variants,
  sizes,
} from '../../../components/CallToAction/styles/CallToAction.styled';

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'max-content')};
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing[8]};
  padding: ${spacing[10]} ${spacing[14]};
  border-radius: ${spacing[8]} ${spacing[0]} ${spacing[0]} ${spacing[8]};
  border: 1px solid ${color.grey[300]};
  background: ${color.common.white};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: border-color 250ms ease-in-out;

  ${({ isSearched, dropdownOpen }) =>
    dropdownOpen &&
    isSearched &&
    css`
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    `}

  &:hover {
    border-color: ${color.grey[500]};

    ${({ isSearched }) =>
      isSearched &&
      css`
        border-color: ${color.grey[300]};
      `}
  }

  ${({ isFocused }) => {
    if (isFocused) {
      return css`
        border-color: ${color.grey[300]} !important;
      `;
    }
  }}
`;

export const Label = styled.label`
  display: none;
`;

export const Input = styled.input`
  width: 100%;
  min-width: 280px;
  border: none;
  outline: none;
  padding: ${spacing[0]};
  margin: ${spacing[0]};
  background-color: ${color.common.transparent};
  color: ${color.darkBlue[600]};
  ${font('text', 'md', '400')}

  &::placeholder {
    color: ${color.darkBlue[600]};
  }
`;

export const Button = styled.button`
  text-align: center;
  transition: all 250ms ease-in-out;
  ${defaultStyles}
  ${sizes.sm}
  ${variants['Filled - Blue']}
  padding: ${spacing[10]} ${spacing[16]};
  border-radius: ${spacing[0]} ${spacing[8]} ${spacing[8]} ${spacing[0]};
  ${atMinWidth.md`
      ${sizes.md}
  `}
  ${atMinWidth.xl`
      ${sizes.lg}
  `}
`;
